<div class="action-container">
  <div class="action" [class.spinner]="inProgress" (click)="click()">
    <i [class]="icon"></i>
  </div>
  @if (label) {
    <div class="label">{{ label | translate }}</div>
  }
</div>
